<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createGroupVisit" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td>{{ item.title_th }}</td>
              <td>{{ item.contact_email }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showGroupVisitData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputSearch from "../../../components/Input/InputSearch";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "GroupVisitTable",
  components: {Paginate, IconPencil, CircleButton, InputSearch },
  data() {
    return {
      title: "Group Visit",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Group visit" },
        { id: 4, text: "Contact email" },
        { id: 5, text: "Update date" },
        { id: 6, text: "edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getGroupVisitTable(1);
  },

  methods: {
    getGroupVisitTable(page) {
      this.$store.dispatch("GroupVisit/getGroupVisit", page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("GroupVisit/getGroupVisit", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    goTOGroupVisitEdit() {
      this.$router.push("/group-visit/edit");
    },
    showGroupVisitData(id) {
      this.$store.dispatch("GroupVisit/showGroupVisit", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("GroupVisit/setFormGroupVisit", res.result).then(() => {
            this.goTOGroupVisitEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    createGroupVisit() {
      this.$store.dispatch("GroupVisit/clearFormData").then(() => {
        this.goTOGroupVisitEdit();
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
